module.exports = "/_next/static/images/instagram-icon-c244cedf158481b691cafa1ca08f9a87.svg";